export default "__VITE_ASSET__BnlGlz$z__"